import { Card, Container } from "react-bootstrap";

import { Buttons } from "@/ui/Buttons";
import cn from "classnames";
import classes from "./styles.module.scss";

export default function ({
  className,
  title,
  content,
  image = "/assets/mini_hero.webp",
  imageClassName,
  buttons,
  overlayClassName,
  EditableImage,
  EditableText,
  EditableHtml,
  theme = "light",
}) {
  return (
    <Card className={cn(className, classes.MiniHero)} data-bs-theme={theme}>
      <Card.Img as="div">
        <EditableImage path="image" src={image} className={imageClassName} size="1440x248" />
      </Card.Img>
      <Card.ImgOverlay className={overlayClassName}>
        <Container fluid="md" className="py-5">
          {title && (
            <EditableText tag="h2" path="title" className="text-balance">
              <span dangerouslySetInnerHTML={{ __html: title }} />
            </EditableText>
          )}
          {content && (
            <EditableHtml path="content" className="text-balance">
              <span dangerouslySetInnerHTML={{ __html: content }} />
            </EditableHtml>
          )}
          {buttons && (
            <div>
              <Buttons className="flex-row" buttons={buttons} />
            </div>
          )}
        </Container>
      </Card.ImgOverlay>
    </Card>
  );
}
